module.exports = __webpack_public_path__ + "img/logistik.c039f658.svg";